/**
 * Utilitário para combinar classes CSS condicionalmente
 * Substitui múltiplas implementações locais da mesma função
 */
export function classNames(...classes: string[]): string {
    return classes.filter(Boolean).join(' ');
} 